import { BaseService } from "Service/BaseService";
import { Configuration } from "Configuration";

import { VersionInfo, VersionClient } from "./Client";

/**
 * Service for versions.
 * @hidden
 */
export class VersionService extends BaseService {
    /**
     * Get dms version info.
     * @param gridId Grid ID.
     * @param filterId Filter ID.
     * @param textBlockCategory TextBlockCategory.
     * @param commandOption CommandOption.
     */
    public get(): Promise<VersionInfo> {
        let client = new VersionClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();
        return new Promise<VersionInfo>((resolve, reject) => {
            /* let xhr =*/ client.get(
                (res) => {
                    resolve(res);
                },
                (exception, reason) => {
                    reject(reason);
                }
            );
            // token.onCancelled((reason) => {
            //     xhr.abort();
            //     reject(reason);
            // });
        });
    }
}
